import { useState } from 'react';
import { getStoredRpcUrl, setStoredRpcUrl, clearStoredRpcUrl } from '../utils/rpcSettings';

export function RpcSettings() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(() => getStoredRpcUrl() ?? '');
  const stored = getStoredRpcUrl();

  const handleSave = () => {
    const trimmed = value.trim();
    if (trimmed) {
      setStoredRpcUrl(trimmed);
    } else {
      clearStoredRpcUrl();
    }
    window.location.reload();
  };

  const handleReset = () => {
    clearStoredRpcUrl();
    window.location.reload();
  };

  return (
    <div className="rpc-settings">
      <button
        type="button"
        className="rpc-settings-toggle"
        onClick={() => setOpen((o) => !o)}
        title="RPC settings"
        aria-label="RPC settings"
      >
        ⚙︎
      </button>
      {open && (
        <div className="rpc-settings-panel">
          <p className="rpc-settings-label">Optimism RPC URL</p>
          <p className="rpc-settings-hint">
            Override the default public RPC. Leave empty to use the default.
          </p>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="https://..."
            className="rpc-settings-input"
            spellCheck={false}
            autoCapitalize="off"
          />
          <div className="rpc-settings-actions">
            <button
              type="button"
              onClick={handleSave}
              className="btn-primary btn-small"
              disabled={value.trim() === (stored ?? '')}
            >
              Save & reload
            </button>
            {stored && (
              <button
                type="button"
                onClick={handleReset}
                className="btn-secondary btn-small"
              >
                Reset to default
              </button>
            )}
          </div>
          {stored && (
            <p className="rpc-settings-current">
              Current: <code>{stored}</code>
            </p>
          )}
        </div>
      )}
    </div>
  );
}
